import axios from "axios";

export const url = process.env.API_URL;
export default axios.create({
  baseURL: url,
});
